import { render } from "./ExamConsentOffcanvas.vue?vue&type=template&id=14a8594c&scoped=true"
import script from "./ExamConsentOffcanvas.vue?vue&type=script&lang=js"
export * from "./ExamConsentOffcanvas.vue?vue&type=script&lang=js"

import "./ExamConsentOffcanvas.vue?vue&type=style&index=0&id=14a8594c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a8594c"]])

export default __exports__